export const EMAIL_PAGE_MAX_WIDTH = 600;

export const HERO_BLOCK_HEIGHT = 140;

export const TEXT_LINE_HEIGHT = 14;

export const TEXT_GROUP_ONE_LINE_COUNT = 3;

export const TEXT_GROUP_TWO_LINE_COUNT = 2;

export const BUTTON_BLOCK_HEIGHT = 44;

export const BUTTON_BLOCK_WIDTH = 160;

export const FOOTER_LINE_HEIGHT = 12;

export const FOOTER_LINE_WIDTH = '50%';

export const TEXT_GROUP_LAST_LINE_WIDTH = '70%';
